import { ThemeProvider } from '@mui/material/styles';
import { forwardRef } from 'react';

export default forwardRef(({ children, ...rest }, ref) => {
    return (
        <ThemeProvider ref={ref} {...rest}>
            {children}
        </ThemeProvider>
    );
});
